module.exports = __webpack_public_path__ + "static/img/bgc-img.a1895a2a.png";